/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Popper, IconButton, Typography, Accordion, AccordionSummary, AccordionDetails, AccordionActions, LinearProgress, Tooltip, Avatar, Divider, Button, ClickAwayListener } from '@material-ui/core'
import { ExpandMore, FlashOn, BubbleChart, Label, Category, CheckCircleOutline, Schedule } from '@material-ui/icons';

import TrainingStage from './TrainingStage'


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    small_avatar : {
        width : theme.spacing(4),
        height : theme.spacing(4),
        backgroundColor : "#FF6701", 
        marginRight : '5px'
    },
    avatar : {
        width : theme.spacing(5),
        height : theme.spacing(5),
        backgroundColor : "#FF6701", 
        marginRight : '5px'
    },
    icon : {
        fontSize : theme.spacing(3)
    },
    small_icon : {
        fontSize : theme.spacing(2)
    },
    connector : {
        flexGrow : 1,
        height : '3px'
    }
})

class Operation extends Component {
    state = {
        open : false
    }

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100', padding: '5px'}}>
                    <Accordion expanded = {this.state.open} onChange = {() => this.setState({...this.state, open : !this.state.open})} style = {{borderLeft : '3px solid #FF6701'}} square variant = 'outlined'>
                        <AccordionSummary
                            style = {{backgroundColor : '#FAFBFC'}}
                            expandIcon={<ExpandMore fontSize = 'small'/>}
                        >
                            <div style = {{width : '100%'}}>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    {this.props.op_label ? <div style = {{flexGrow : 1 ,display : 'flex', flexDirection : 'row', alignItems: 'center'}}>
                                        <Avatar className = {this.props.size === "small" ? classes.small_avatar : classes.avatar}
                                            // style = {{width : '35px', height : '35px', backgroundColor : "#FF6701", marginRight : '5px'}}
                                        >
                                            <FlashOn className = {this.props.size === "small" ? classes.small_icon : classes.icon}/>
                                        </Avatar>
                                        <Typography style = {{color : "#FF6701"}} variant = 'body2'>{this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).annotation}</Typography>
                                        {this.props.ic.operationAnnotations.find(op_annot => op_annot.type === this.props.op).is_schedulable && this.props.ic.scheduleJob !== null ? 
                                            <Tooltip title = "Retraining of this operation has a schedule.">
                                                <Schedule style = {{marginLeft : '5px', fontSize : '20px', color : '#2296f3'}}/> 
                                            </Tooltip>
                                        : null}
                                    </div> : null}
                                    {this.state.open === false ? <div style = {{flexGrow : 1.5}}>
                                        <TrainingStage ic = {this.props.ic} op = {this.props.op} size = "small" interaction = {false} refresh = {this.props.refresh}/>
                                    </div> : null}
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style = {{width : '100%', padding : '5px'}}>
                                <Typography style = {{marginBottom : '5px'}} variant = 'subtitle2' color = 'textSecondary'>Training Stages</Typography>
                                <TrainingStage ic = {this.props.ic} op = {this.props.op} size = "medium" interaction = {true} refresh = {this.props.refresh}/>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Operation);